<ng-template #popoverTaxes>
  <div class="container-taxes">
    @if (rate) {
      <div class="taxe bold">
        <p class="name-taxe">
          @if (fop === 'PAY_AT_DESTINATION') {
            <strong> Valor en dólares</strong>
          } @else {
            <strong>{{ rate.key }}</strong>
          }
        </p>
        <p class="value-taxe">
          @if (currencyCode === 'USD') {
            <strong>u$s {{ rate.value | Currency }}</strong>
          } @else {
            <strong>{{ fop === 'PAY_AT_DESTINATION' ? 'u$s' : '$' }}
            {{ rate.value | Currency }}</strong>
          }
        </p>
      </div>
    }
    <ul>
      @if (fop === 'PAY_AT_DESTINATION') {
        <li>
          <div class="taxe">
            @if (currencyCode !== 'USD') {
              <p class="name-taxe">El precio en pesos argentinos es estimativo</p>
            }
          </div>
        </li>
      }
      @for (charge of charges; track charge) {
        <li>
          <div class="taxe">
            <p class="name-taxe">{{ charge.key }}</p>
            @if (currencyCode === 'USD') {
              <p class="value-taxe">u$s {{ charge.value | Currency }}</p>
            } @else {
              <p class="value-taxe">$ {{ charge.value | Currency }}</p>
            }
          </div>
        </li>
      }
    </ul>
    @if (information) {
      <div class="disclaimer">
        <mb-icon icon="exclamation-circle" class="icon-focus"></mb-icon>
        <p class="disclaimer__text not-pad">@if (information?.title) {<strong>{{ information?.title }}.</strong>} {{ information?.information[0] }}</p>
      </div>
    }
  </div>
</ng-template>
<div
[mb-popover]="popoverTaxes"
[mbPopoverShow]="false"
mbPopoverColor="light"
mbPopoverPosition="left"
>

</div>
